module.exports = __webpack_public_path__ + "static/media/Cityscape-Wellington-cable-car.b357494e.jpg";